import script from "./VAForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./VAForm.vue?vue&type=script&lang=ts&setup=true"

import "./VAForm.vue?vue&type=style&index=0&id=06310e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06310e5a"]])

export default __exports__